import React from "react";

// components


//styles
import cx from "classnames";


const ProductNavigationV3: React.FC = () => {

        return (
            <React.Fragment>
                <div className={cx("layout-flex-row gap-2xl layout-multi-product-items")}>
                    <div className={cx("layout-flex-row layout-product-container")} >
                        <img src="/images/svg/icons/icon-product-life.svg" alt="Life logo" className="icon-product" />
                        <div className={cx("layout-flex-column", "layout-multi-product")} >
                            <h3>Life insurance</h3>
                            <p className="text-font-size-s">A lump sum paid to your loved ones if you pass away. <a href="/life-insurance/about">Learn more</a></p>
                            <a className="btn-secondary" href="/compare/family-settings/life">Compare quotes</a>
                        </div>
                    </div>
                    <div className={cx("layout-flex-row layout-product-container")} >
                        <img src="/images/svg/icons/icon-product-health.svg" alt="Life logo" className="icon-product" />
                        <div className={cx("layout-flex-column", "layout-multi-product")} >
                            <h3>Health insurance</h3>
                            <p className="text-font-size-s">Skip public waiting lists and get better sooner. <a href="/health-insurance/about">Learn more</a></p>
                            <a className="btn-secondary" href="/compare/family-settings/health">Compare quotes</a>
                        </div>
                    </div>
                    <div className={cx("layout-flex-row layout-product-container")} >
                        <img src="/images/svg/icons/icon-product-income.svg" alt="Life logo" className="icon-product" />
                        <div className={cx("layout-flex-column", "layout-multi-product")} >
                            <h3>Income protection</h3>
                            <p className="text-font-size-s">Protect your income if you are unable to work. <a href="/income-protection/about">Learn more</a></p>
                            <a className="btn-secondary" href="/compare/family-settings/income">Compare quotes</a>
                        </div>
                    </div>
                    <div className={cx("layout-flex-row layout-product-container")} >
                        <img src="/images/svg/icons/icon-product-contents.svg" alt="Life logo" className="icon-product" />
                        <div className={cx("layout-flex-column", "layout-multi-product")} >
                            <h3>House &amp; Contents</h3>
                            <p className="text-font-size-s">Cover your building and contents from loss or damage. <a href="/house-contents-insurance/about">Learn more</a></p>
                            <a className="btn-secondary" href="/house-contents-insurance">Compare quotes</a>
                        </div>
                    </div>
                    <div className={cx("layout-flex-row layout-product-container")} >
                        <img src="/images/svg/icons/icon-product-trauma.svg" alt="Life logo" className="icon-product" />
                        <div className={cx("layout-flex-column", "layout-multi-product")} >
                            <h3>Trauma insurance</h3>
                            <p className="text-font-size-s">A lump sum paid to your loved ones if the unexpected happens. <a href="/trauma-insurance/about">Learn more</a></p>
                            <a className="btn-secondary" href="/compare/family-settings/trauma">Compare quotes</a>
                        </div>
                    </div>
                    <div className={cx("layout-flex-row layout-product-container")} >
                        <img src="/images/svg/icons/icon-product-mortgage-insurance.svg" alt="Life logo" className="icon-product" />
                        <div className={cx("layout-flex-column", "layout-multi-product")} >
                            <h3>Mortgage insurance</h3>
                            <p className="text-font-size-s">Protect your mortgage payments if you're not able to work. <a href="/mortgage-insurance/about">Learn more</a></p>
                            <a className="btn-secondary" href="/compare/family-settings/mortgage">Compare quotes</a>
                        </div>
                    </div>
                    <div className={cx("layout-flex-row layout-product-container")} >
                        <img src="/images/svg/icons/icon-product-business.svg" alt="Life logo" className="icon-product" />
                        <div className={cx("layout-flex-column", "layout-multi-product")} >
                            <h3>Business insurance</h3>
                            <p className="text-font-size-s">Protect the income of your business if disaster strikes. <a href="/business-insurance/about">Learn more</a></p>
                            <a className="btn-secondary" href="/business-insurance">Compare quotes</a>
                        </div>
                    </div>
                    <div className={cx("layout-flex-row layout-product-container")} >
                        <img src="/images/svg/icons/icon-product-car.svg" alt="Life logo" className="icon-product" />
                        <div className={cx("layout-flex-column", "layout-multi-product")} >
                            <h3>Car insurance</h3>
                            <p className="text-font-size-s">Cover costs if your car is involved in an accident. <a href="/car-insurance/about">Learn more</a></p>
                            <a className="btn-secondary" href="/car-insurance">Compare quotes</a>
                        </div>
                    </div>
                    <div className={cx("layout-flex-row layout-product-container")} >
                        <img src="/images/svg/icons/icon-product-pet.svg" alt="Life logo" className="icon-product" />
                        <div className={cx("layout-flex-column", "layout-multi-product")} >
                            <h3>Pet insurance</h3>
                            <p className="text-font-size-s">Cover a portion of eligible pet bills. <a href="/pet-insurance/about">Learn more</a></p>
                            <a className="btn-secondary" href="/pet-insurance">Compare quotes</a>
                        </div>
                    </div>
                </div>
            </React.Fragment>
    );
};

export default ProductNavigationV3;